const category = {
  LEAD_GENERATION: { value: 'lead-generation', label: 'Lead Generation' },
  FEEDBACK: { value: 'feedback', label: 'Feedback' },
  ANNOUNCEMENT: { value: 'announcement', label: 'Announcement' },
  CUSTOMER_SEGMENTATION: { value: 'segmentation', label: 'Customer Segmentation' },
  COUPONS_OFFERS: { value: 'coupons-offers', label: 'Coupons & Offers' },
  AGE_VERIFICATION: { value: 'age-verification', label: 'Age Verification' },
  // AUDIENCE_ENGAGEMENT: { value: 'audience-engagement', label: 'Audience Engagement' },
}

const tag = {
  POPUP: { value: 'popup', label: 'Popup' },
  FLYOUT: { value: 'flyout', label: 'Flyout' },
  GAMIFICATION: { value: 'gamification', label: 'Gamification' },
  STICKY_BAR: { value: 'sticky bar', label: 'Sticky Bar' },
  // FULL_SCREEN: { value: 'full-screen', label: 'Full Screen' },
}

const industry = {
  SOFTWARE_TECHNOLOGY: { value: 'technology', label: 'Technology' },
  BUSINESS: { value: 'business', label: 'Business' },
  EDUCATION: { value: 'education', label: 'Education' },
  ENTERTAINMENT: { value: 'entertainment', label: 'Entertainment' },
  TRAVEL_TOURISM: { value: 'travel-tourism', label: 'Travel & Tourism' },
  FASHION: { value: 'fashion', label: 'Fashion' },
  FOOD: { value: 'food', label: 'Food' },
  HEALTH_WELLNESS: { value: 'health-wellness', label: 'Health & Wellness' },
}

export { category, tag, industry }